import { createSelector } from 'reselect';
import { flattenIndustries, regionsParser } from 'shared/parsers';
import { sortBy } from 'lodash';

const getShared = ({ shared }) => shared;
export const getAllIndustries = createSelector(getShared, ({ industries }) => industries);

export const getRelatedIndustries = createSelector(
  getShared,
  ({ relatedIndustries }) => relatedIndustries,
);
export const getAllIndustriesData = createSelector(getAllIndustries, ({ data }) => data);
export const getESGCoverage = createSelector(getShared, ({ esgCoverage }) => esgCoverage);
export const getRegions = createSelector(getShared, ({ regions }) => regions);

export const getParsedRegions = createSelector(getRegions, regions =>
  regions.isPending ? regions : { ...regions, data: regionsParser(regions.data) },
);

export const getSearchableRegions = createSelector(getRegions, regions =>
  regions.isPending ? regions : { ...regions, data: regionsParser(regions.data, true) },
);

export const getFlattenedIndustries = createSelector(getAllIndustriesData, industries =>
  flattenIndustries(industries),
);

export const getSortedFlattenedIndustries = createSelector(getFlattenedIndustries, data =>
  sortBy(data, ['industryName', 'name']),
);

export const getSearchbleIndustries = createSelector(getAllIndustriesData, industries =>
  flattenIndustries(industries, true),
);

export const getFilterableIndustries = createSelector(
  getRelatedIndustries,
  getFlattenedIndustries,
  (relatedIndustries, flattenedIndustries) =>
    relatedIndustries.reduce((extendedIndustries, industryName) => {
      const industry = flattenedIndustries.find(({ name }) => name === industryName);
      if (industry) extendedIndustries.push(industry);
      return extendedIndustries;
    }, []),
);

export const getIndustryByName = industryName =>
  createSelector(getFlattenedIndustries, industries =>
    industries.find(({ name }) => name === industryName),
  );

export const getSortedFilterableIndustries = createSelector(getFilterableIndustries, data =>
  sortBy(data, ['industryName', 'name']),
);

export const getCurrentIndustry = (code, industryCode) =>
  createSelector(getFlattenedIndustries, industries =>
    industries.find(({ code: c, industryCode: ic }) => code === c && industryCode === ic),
  );

const getSearchResult = ({ searchResult }) => searchResult;
export const getSearchResultEntities = createSelector(getSearchResult, ({ entities }) => entities);
export const getSearchResultEntitiesByRatingType = ratingType =>
  createSelector(getSearchResultEntities, entities => entities.byRatingType[ratingType]);

const getNewsFeed = ({ newsFeed }) => newsFeed;
export const getNewsFeedShouldRefresh = createSelector(
  getNewsFeed,
  ({ shouldRefresh }) => shouldRefresh,
);
export const getNewsFeedPreferences = createSelector(getNewsFeed, ({ preferences }) => preferences);
export const getNewsFeedPreferencesIsPending = createSelector(
  getNewsFeedPreferences,
  ({ isPending }) => isPending,
);

const getSharedQuestionnaire = createSelector(getShared, ({ questionnaire }) => questionnaire);
export const getSharedQuestionareShow = createSelector(getSharedQuestionnaire, ({ show }) => show);
